<template>
  <div>
    <customize-page
      label-position="left"
      ref="page"
      inline
      :loading="loading"
      :data="dataList"
      :columns="columns"
      :pagination="pagination"
      :formConfig="getFormConfig()"
      :filterObj="filterObj"
      @size-change="handleSizeChange"
      @on-selection-change="selectionChange"
      @current-change="handleCurrentChange"
    >
      <div slot="footer">
        <el-button style="margin-right: 10px" type="primary" @click="fetch">
          搜索
        </el-button>
        <el-button style="margin-right: 10px" @click="reset">重置</el-button>
        <el-button style="margin-right: 10px" @click="exportList">
          导出
        </el-button>
        <el-button
          style="margin-right: 10px"
          type="primary"
          @click="retryTaskSelection"
        >
          立即重试
        </el-button>
        <el-button
          style="margin-right: 10px"
          type="danger"
          @click="batchDelete"
        >
          删除
        </el-button>
        <p class="inline-p">
          同步异常单共<span style="padding: 0 5px">{{ orderErrorCount }}</span
          >条数据
        </p>
      </div>
    </customize-page>

    <el-dialog title="查看" width="1050px" :visible.sync="showDialog">
      <el-form
        style="width: 1000px; margin: 0 auto"
        ref="form"
        :model="currentShowData"
        label-width="120px"
      >
        <el-form-item label="订单号">
          {{ currentShowData.originOrderNo }}
        </el-form-item>
        <el-form-item label="异常原因">
          {{ currentShowData.message }}
        </el-form-item>
        <el-form-item label="数据">
          {{ currentShowData.data }}
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="hide">关闭</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import Page from "@/mixin/Page";
import CustomizePage from "@/components/customize-page";
import orderApi from "@/api/order";
import authApi from "@/api/auth";
import shopAuthApi from "@/api/shopAuthApi";
import _ from "lodash";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {
    CustomizePage,
  },
  mixins: [Page],
  created() {
    authApi.getOmsUserInfo().then((res) => {
      this.userInfo = res;
      this.fetch();
    });
  },
  mounted() {
    this.fetchAllShop();
  },
  data() {
    return {
      loading: false,
      showDialog: false,
      userInfo: {},
      dataList: [],
      shopList: [],
      orderErrorCount: 0,
      columns: [
        {
          type: "selection",
          width: 50,
          align: "center",
          fixed: "left",
        },
        {
          title: "店铺名称",
          align: "center",
          render: (h, param) => {
            if (this.shopList.length > 0) {
              const shopCode = param.row.shopCode;
              const shop = _.find(this.shopList, { value: shopCode });
              const shopTypeMap = {
                PINDUODUO: "拼多多",
                MEITUAN: "美团",
                YANGCONG: "洋葱",
                JD: "京东",
              };
              return (
                <p>
                  {shopTypeMap[shop.type]}:{shop.label}
                </p>
              );
            }
            return null;
          },
        },
        { title: "订单号", key: "originOrderNo", align: "center" },
        {
          title: "异常原因",
          key: "message",
          align: "center",
        },
        {
          title: "预售",
          key: "isPreSales",
          align: "center",
          width: 60,
          render: (h, param) => {
            const isPreSales = param.row.isPreSales;
            return <div>{isPreSales ? "是" : "否"}</div>;
          },
        },
        { title: "预售最后发货时间", key: "preSalesDate", align: "center" },
        {
          title: "创建/更新时间",
          key: "gmtCreate",
          align: "center",
          render: (h, param) => {
            return (
              <div>
                {param.row.gmtCreate}
                <br />
                {param.row.gmtModified}
              </div>
            );
          },
        },
        {
          title: "操作",
          width: 180,
          align: "center",
          render: (h, param) => {
            let data = param.row;
            const shopCode = param.row.shopCode;
            const shop = _.find(this.shopList, { value: shopCode });
            return (
              <div>
                {["DOUYIN", "PINDUODUO", "HIPAC", "JD"].includes(shop.type) ? (
                  <a
                    style="color:blue;margin-right:10px;"
                    onClick={this.retry.bind(this, data)}
                  >
                    重试
                  </a>
                ) : null}
                {shop.type !== "DOUYIN" ? (
                  <a
                    style="color:blue;margin-right:10px;"
                    onClick={this.show.bind(this, data)}
                  >
                    查看
                  </a>
                ) : null}
                <a style="color:blue" onClick={this.delete.bind(this, data)}>
                  删除
                </a>
              </div>
            );
          },
        },
      ],
      filterObj: {
        originOrderNo: "",
        createTime: [
          new Date(
            parseFloat(
              moment()
                .subtract(6, "day")
                .startOf("day")
                .format("x")
            )
          ),
          new Date(
            parseFloat(
              moment()
                .endOf("day")
                .format("x")
            )
          ),
        ],
      },
      currentShowData: {},
      currentRow: [],
      sortObj: {},
    };
  },
  computed: {
    ...mapGetters({
      getCustomerList: "getCustomerList",
    }),
  },
  methods: {
    retry(row) {
      orderApi.orderErrorRetry({ orderErrorId: row.id }).then((res) => {
        this.$message.success("重试成功");
        this.fetch();
      });
    },
    show(row) {
      this.showDialog = true;
      this.currentShowData = row;
    },
    delete(row) {
      this.$confirm("确认删除该条数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        orderApi.orderErrorDelete({ orderErrorId: row.id }).then((res) => {
          this.$message.success("删除成功");
          this.fetch();
        });
      });
    },
    hide() {
      this.showDialog = false;
    },
    fetch() {
      this.loading = true;
      const filterParams = this.getFilterParams();
      if (filterParams.createTime != null) {
        filterParams.gmtCreateStart = moment(filterParams.createTime[0]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        filterParams.gmtCreateEnd = moment(filterParams.createTime[1]).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        delete filterParams.createTime;
      }

      if (filterParams.preSalesTime != null) {
        filterParams.preSalesStart = filterParams.preSalesTime[0];
        filterParams.preSalesEnd = filterParams.preSalesTime[1];
        delete filterParams.preSalesTime;
      }

      if (this.userInfo.customerId) {
        filterParams.customerId = this.userInfo.customerId;
      }

      orderApi
        .orderErrorPageQuery({
          request: {
            isPreSales: filterParams.isPreSales,
            message: filterParams.message,
            gmtCreateStart: filterParams.gmtCreateStart,
            gmtCreateEnd: filterParams.gmtCreateEnd,
            preSalesStart: filterParams.preSalesStart,
            preSalesEnd: filterParams.preSalesEnd,
            originOrderNo: filterParams.originOrderNo,
            shopCode: filterParams.shopCode,
            shopType: filterParams.shopType,
            customerId: filterParams.customerId,
            pageInfo: {
              currentPage: this.pagination.currentPage,
              pageSize: this.pagination.pageSize,
            },
          },
        })
        .then((res) => {
          this.dataList = res.items;
          this.pagination.currentPage = res.page.pageIndex;
          this.pagination.pageSize = res.page.pageSize;
          this.pagination.totalCount = res.page.totalCount;
          this.orderErrorCount = res.page.totalCount;
          this.loading = false;
        });
    },
    batchDelete() {
      if (this.currentRow.length <= 0) {
        this.$message.warning("请勾选需要删除的订单");
        return;
      }
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const promiseArr = [];
        for (let index in this.currentRow) {
          promiseArr.push(
            orderApi.orderErrorDelete({
              orderErrorId: this.currentRow[index].id,
            })
          );
        }
        Promise.all(promiseArr).then(() => {
          this.$message.success("删除成功");
          this.fetch();
        });
      });
    },
    retryTaskSelection() {
      if (this.currentRow.length <= 0) {
        this.$message.warning("请勾选需要重试的订单");
        return;
      }
      const promiseArr = [];
      for (let index in this.currentRow) {
        promiseArr.push(
          orderApi.orderErrorRetry({ orderErrorId: this.currentRow[index].id })
        );
      }
      Promise.all(promiseArr).then(() => {
        this.$message.success("重试成功");
        this.fetch();
      });
    },
    selectionChange(row) {
      this.currentRow = row;
    },
    fetchAllShop() {
      return shopAuthApi
        .listAll()
        .then((res) => {
          this.shopList = res.items
            .filter((item) => {
              if (!this.userInfo.customerId) {
                return true;
              }
              return item.customerId === this.userInfo.customerId;
            })
            .map((res) => {
              return {
                label: res.shopName,
                value: res.shopCode,
                type: res.shopType,
              };
            });
        })
        .catch(() => {
          this.$message.error("店铺列表加载失败，请刷新页面重试");
        });
    },
    exportList() {
      this.loading = true;
      const filterParams = this.getFilterParams();

      if (filterParams.createTime != null) {
        filterParams.gmtCreateStart = filterParams.createTime[0];
        filterParams.gmtCreateEnd = filterParams.createTime[1];
        delete filterParams.createTime;
      }

      if (filterParams.preSalesTime != null) {
        filterParams.preSalesStart = filterParams.preSalesTime[0];
        filterParams.preSalesEnd = filterParams.preSalesTime[1];
        delete filterParams.preSalesTime;
      }

      if (this.userInfo.customerId) {
        filterParams.customerId = this.userInfo.customerId;
      }
      orderApi
        .orderErrorExport({
          request: {
            ...filterParams,
            pageInfo: {
              currentPage: 1,
              pageSize: 9999,
            },
          },
        })
        .then((res) => {
          if (res.value) {
            this.$alert("提交成功", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.$router.push({ name: "download" });
              },
            });
          } else {
            this.$message.error("提交失败");
          }
        });
    },
    getFormConfig() {
      const type = this.getFormItemType();
      const customerIdFilter = [];
      if (!this.userInfo.customerId) {
        customerIdFilter.push({
          label: "货主id",
          model: "customerId",
          type: type.SELECT,
          props: {
            data: this.getCustomerList,
          },
        });
      }
      return [
        {
          data: [
            {
              label: "商户订单号",
              model: "originOrderNo",
              type: type.INPUT,
            },
            ...customerIdFilter,
            {
              label: "平台",
              model: "shopType",
              type: type.SELECT,
              props: {
                data: [
                  { label: "全部", value: "" },
                  { label: "拼多多", value: "PINDUODUO" },
                  { label: "美团", value: "MEITUAN" },
                  { label: "抖音", value: "DOUYIN" },
                  { label: "洋葱", value: "YANGCONG" },
                  { label: "京东", value: "JD" },
                  { label: "得物", value: "DEWU" },
                ],
              },
            },
            {
              label: "店铺",
              model: "shopCode",
              type: type.SELECT,
              props: {
                data: this.shopList,
              },
            },
            {
              label: "异常信息",
              model: "message",
              type: type.INPUT,
            },
            {
              label: "是否预售",
              model: "isPreSales",
              type: type.SELECT,
              props: {
                data: [
                  { label: "全部", value: "" },
                  { label: "是", value: 1 },
                  { label: "否", value: 2 },
                ],
              },
            },
            {
              label: "创建时间",
              model: "createTime",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
            },
            {
              label: "预售最后发货时间",
              model: "preSalesTime",
              type: type.DATETIME_RRANGE,
              className: "flex-form-item",
            },
          ],
        },
      ];
    },
  },
};
</script>

<style lang="scss" scope>
.inline-p {
  display: inline-block;
  span {
    color: red;
  }
}
</style>
